@if(planner(); as planner) {
<div
  class="mt-1 jax-theme-classic"
  [class.single-column-layout]="settings().singleColumn"
>
  <h5
    class="bg-secondary text-white px-2 rounded-top py-2 mb-1 d-flex planner-header"
    [class.rounded-bottom]="!expanded()"
  >
    <a (click)="toggle()" class="d-block">
      <fa-icon
        [icon]="expanded() ? icons.closedIcon : icons.openedIcon"
        [fixedWidth]="true"
      ></fa-icon>
      <span class="ms-1"
        >{{ planner.planner_name }}
        {{ planner.owner.username ?? planner.owner.email }}</span
      >
    </a>
  </h5>
  <ng-container *ngIf="expanded()">
    <div
      class="week-container"
      *ngFor="
        let week of weeks();
        trackBy: trackByWeek;
        let w = index;
        let lastWeek = last
      "
    >
      <div class="calendar-grid">
        <div
          class="col-day"
          *ngFor="
            let day of week.days;
            trackBy: trackByDay;
            let firstDay = first
          "
        >
          <app-learn-planner-day
            [planner]="planner"
            [day]="day"
            [isBottomLeft]="lastWeek && firstDay"
          ></app-learn-planner-day>
        </div>
      </div>
      <div class="week bg-warning" [class.bbr]="lastWeek">
        <div class="text-center week-text">Week {{ w + 1 }}</div>
        <span *ngIf="false">
          <fa-icon [icon]="icons.copyIcon"></fa-icon>
        </span>
      </div>
    </div>
  </ng-container>
</div>
}
